import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { RedirectProps } from 'src/hooks/useRedirect.types';
import { useStoreActions } from 'src/stores';
import { PopUpEnum } from 'src/stores/NotificationStore';

export const useRedirect = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const setPopUpData = useStoreActions(action => action.popUp.setPopUp);

  const handleRedirect = ({ route, id, extraState }: RedirectProps) => {
    if (!route) {
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.error,
        message: t('redirect.error'),
      });
      return;
    }

    const path = id ? `${route}/${id}` : route;

    try {
      history.push({ pathname: path, state: extraState });
    } catch (error) {
      console.error('Redirection failed:', error);
      setPopUpData({
        isOpen: true,
        type: PopUpEnum.error,
        message: t('redirect.error'),
      });
    }
  };

  return { handleRedirect };
};
